import Button from '@ingka/button';
import documentAdd from '@ingka/ssr-icon/paths/document-add';
import Tooltip from '@ingka/tooltip';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectCurrentLanguageCode,
  selectCurrentRetailUnit,
} from '../../../store/slices/intl';
export const RequestLink = () => {
  const retailUnit = useSelector(selectCurrentRetailUnit);
  const languageCode = useSelector(selectCurrentLanguageCode);
  const navigate = useNavigate();
  return (
    <Tooltip
      describedById="market-request-tooltip"
      interactiveCustomTrigger
      position="bottom"
      tooltipText="Market Request"
    >
      <Button
        id="market-request-button"
        aria-label="Go to market request"
        size="small"
        name="Go to market request"
        type="tertiary"
        iconOnly
        role="button"
        ssrIcon={documentAdd}
        onClick={() => {
          const to = `${retailUnit}/${languageCode}/market-request`;
          navigate(to);
        }}
      />
    </Tooltip>
  );
};
